var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8395 5.71427L7.46452 10.0893C7.40355 10.1505 7.3311 10.199 7.25134 10.2321C7.17157 10.2652 7.08605 10.2823 6.99967 10.2823C6.9133 10.2823 6.82778 10.2652 6.74801 10.2321C6.66824 10.199 6.5958 10.1505 6.53483 10.0893L2.15983 5.71427C2.03655 5.59099 1.96729 5.42378 1.96729 5.24943C1.96729 5.07508 2.03655 4.90787 2.15983 4.78458C2.28311 4.6613 2.45032 4.59204 2.62467 4.59204C2.79902 4.59204 2.96623 4.6613 3.08952 4.78458L7.00022 8.69529L10.9109 4.78404C11.0342 4.66075 11.2014 4.59149 11.3758 4.59149C11.5501 4.59149 11.7173 4.66075 11.8406 4.78404C11.9639 4.90732 12.0332 5.07453 12.0332 5.24888C12.0332 5.42323 11.9639 5.59044 11.8406 5.71372L11.8395 5.71427Z",
    fill: "#1C2833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/CaretDown.55c5cf992c7bea757497642250b8b9d2.svg";
export { ForwardRef as ReactComponent };